import { get } from 'lodash';

export const getErrorMessage = (obj: unknown, path: string) => get(obj, path, 'Oops something went wrong!');
